export const products = [
  {
    id: 1,
    name: "GTOWizard",
    logo: "https://static.readdy.ai/image/912e20adcc1f339ca4234f4574745e78/037eaa8f9b9737ec6a26b7c568864e0c.jpeg",
    website: "https://gtowizard.com/p/xiaoyaopoker",
    description: "盈利玩家必备\n数学解决难题\n点击访问官网购买即省10%",
    category: "扑克策略",
    featured: true
  },
  {
    id: 2,
    name: "DeepPineApple",
    logo: "https://public.readdy.ai/ai/img_res/80ee541de3aa5a30f8e31fb94cd2fdef.jpg",
    website: "http://deeppineapple.com/",
    description: "全网最强菠萝AI\n全自动实时响应\n支持手机和模拟器操作\n极简操作零风险运行\n添加客服咨询购买即享最低8折算力折扣\n客服TG：https://t.me/xiaoyaoxiaomei",
    category: "AI工具",
    featured: true
  },
  {
    id: 3,
    name: "Dler Cloud VPN",
    logo: "https://dler.pro/img/img-map.svg",
    website: "https://dler.pro/auth/register?affid=200758",
    description: "逍遥哥多年自用VPN\n官方在线客服支持，使用简单\n支持电脑和手机\n大陆地区连接高速稳定\n打牌看剧保护畅通无阻\n国际大牌，区块链团队首选",
    category: "实用工具",
    featured: false
  }
];
